import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function DeviceUnknownIcon(props: IconProps) {
    return <Icon {...props} iconKey={"device_unknown"}/>
}
